import REQUEST_STATUS from '@common/constants/requestStatus';
import {
  EDITING_MOVE_IN_COSTS,
  EDITING_RENT_TERMS,
  REQUEST_GET_FEATURE_PERMISSIONS,
  REQUEST_LANDLORD_STATUS,
  REQUEST_LANDLORD_STATUS_SETUP_NEW_TERM,
  REQUEST_MARK_COVERAGE_REQUEST_SIGNED,
  REQUEST_RENTAL_PROTECTION_LEGAL_DISCLAIMER,
  RESET_NEW_TERM_SETTINGS,
  RESET_ONE_TIME_PAYMENT_REQUEST,
  SAVE_LISTING_ALIAS,
  SAVE_LISTING_DETAILS,
  SAVE_NEW_TERM_SETTINGS,
  SAVE_ONE_TIME_PAYMENT_REQUEST,
  SETUP_NEW_TERM,
} from '@rental-manager/constants/ActionConstants';

const defaultValues = {
  listingDetails: {},
  listingAlias: '',
  stateCode: '',
  editingRentTerms: {},
  oneTimePaymentRequest: {
    amount: '',
    type: '',
    notes: '',
    rentTermsKey: '',
    currentTenant: {},
    nextTenant: {},
  },
  oneTimePaymentRequestPage: '',
  editingMoveInCostsRequest: {
    groupKey: '',
    tenantFirstName: '',
  },
  newTermSettings: {
    tenantFirstName: '',
    tenantLastName: '',
    tenantEmail: '',
    paymentDayOfTheMonth: 1,
    firstDueDate: '',
    numberOfPayments: '',
    monthToMonth: false,
    rentAmount: 0,
    leaseId: null,
    isSelectedLeaseRProEligible: false,
    currentPage: 0,
  },
};

const initState: any = {};

const propertiesReducer = (state = initState, action) => {
  switch (action.type) {
    case SAVE_LISTING_DETAILS:
      return {
        ...state,
        stateCode: action.listingDetails.state,
        listingDetails: {
          isApplicationsAccepted: action.listingDetails.applicationsAccepted,
          listingAlias: action.listingDetails.listingAlias,
          rentGuarantee: action.listingDetails.rentGuarantee,
          eventProductType: action.listingDetails.eventProductType,
          hasNeverBeenActivated: action.listingDetails.hasNeverBeenActivated,
          webAnalytics: action.listingDetails.webAnalytics,
          contactPhone: action.listingDetails.contactPhone,
        },
      };
    case SAVE_LISTING_ALIAS:
      return {
        ...state,
        listingAlias: action.listingAlias,
      };
    case SETUP_NEW_TERM:
      return {
        ...state,
        newTermDetails: action.payload.data,
        // TODO: Not sure about this
        paymentSettings: {
          ...state.paymentSettings,
          newTerm: true,
        },
      };
    case REQUEST_LANDLORD_STATUS.INIT:
      return {
        ...state,
        requestStatus: REQUEST_STATUS.INIT,
      };
    case REQUEST_LANDLORD_STATUS.SUCCESS:
      return {
        ...state,
        ...action.payload.data,
        requestStatus: REQUEST_STATUS.SUCCESS,
      };
    case REQUEST_LANDLORD_STATUS.FAIL:
      return {
        ...state,
        requestStatus: REQUEST_STATUS.FAIL,
      };
    /*
        Dispatching actions for Setup New Term flow
        to prevent unmounting and re-mounting of Homepage Component
        */
    case REQUEST_LANDLORD_STATUS_SETUP_NEW_TERM.INIT:
      return {
        ...state,
      };
    case REQUEST_LANDLORD_STATUS_SETUP_NEW_TERM.SUCCESS:
      return {
        ...state,
        ...action.payload.data,
        isHighRiskOtpApproved: action.payload.data.isHighRiskOtpApproved,
        requestStatus: REQUEST_STATUS.SUCCESS,
      };
    case REQUEST_LANDLORD_STATUS_SETUP_NEW_TERM.FAIL:
      return {
        ...state,
      };
    case REQUEST_GET_FEATURE_PERMISSIONS.INIT:
      return {
        ...state,
        requestStatus: REQUEST_STATUS.INIT,
      };
    case REQUEST_GET_FEATURE_PERMISSIONS.SUCCESS:
      return {
        ...state,
        ...action.payload.data,
        requestStatus: REQUEST_STATUS.SUCCESS,
      };
    case REQUEST_GET_FEATURE_PERMISSIONS.FAIL:
      return {
        ...state,
        requestStatus: REQUEST_STATUS.FAIL,
      };
    case SAVE_ONE_TIME_PAYMENT_REQUEST:
      return {
        ...state,
        oneTimePaymentRequest: {
          ...action.oneTimePaymentRequest,
        },
      };
    case RESET_ONE_TIME_PAYMENT_REQUEST:
      return {
        ...state,
        oneTimePaymentRequest: defaultValues.oneTimePaymentRequest,
      };
    case EDITING_RENT_TERMS:
      return {
        ...state,
        editingRentTerms: {
          ...state.editingRentTerms,
          ...action.rentTerms,
        },
      };
    case EDITING_MOVE_IN_COSTS:
      return {
        ...state,
        editingMoveInCosts: {
          ...action.editingMoveInCostsRequest,
        },
      };
    case SAVE_NEW_TERM_SETTINGS:
      return {
        ...state,
        newTermSettings: {
          ...state.newTermSettings,
          ...action.newTermSettings,
        },
      };
    case RESET_NEW_TERM_SETTINGS:
      return {
        ...state,
        newTermSettings: defaultValues.newTermSettings,
      };
    case REQUEST_RENTAL_PROTECTION_LEGAL_DISCLAIMER.SUCCESS:
      return {
        ...state,
        rentalProtectionDisclaimers: action.payload.data.disclaimers,
      };
    case REQUEST_MARK_COVERAGE_REQUEST_SIGNED.SUCCESS:
      return {
        ...state,
        currentTerm: {
          ...state.currentTerm,
          rentalProtectionPolicy: {
            ...state.currentTerm.rentalProtectionPolicy,
            coverageRequestSigned: true,
          },
        },
      };
    default:
      return state;
  }
};

export default propertiesReducer;
